// src/components/Footer.js
import React from 'react';
import { Home, List, Heart, ShoppingCart, Truck } from 'lucide-react';
import './Footer.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useProductState } from '../contexts/ProductContext';
import { getLastSelectedSegment } from '../utils/segmentCache';

const defaultCatalogueRoute = () =>
  `/productSegment/${getLastSelectedSegment() || 'GOLD'}`;

const Footer = ({
  navigationRoutes,
  catalogueRoute,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { likedProducts, selectedProducts } = useProductState();

  const routes = {
    home: '/dashboard',
    catalogue: catalogueRoute || defaultCatalogueRoute(),
    favorite: '/favorite',
    selections: '/selections',
    orders: '/orderflow',
    ...navigationRoutes,
  };

  // Calculate badge count for Selections - always show total count of selected products
  // The badge represents total items in selection cart, regardless of serviceType
  const getSelectionBadge = () => {
    return selectedProducts.length;
  };

  // nav items config (same style as 2nd footer)
  const footerItems = [
    { id: 'home', label: 'Home', icon: Home, route: routes.home },
    { id: 'catalogue', label: 'Categories', icon: List, route: routes.catalogue },
    {
      id: 'favorite',
      label: 'Favourite',
      icon: Heart,
      route: routes.favorite,
      badge: likedProducts.length,
    },
    {
      id: 'selections',
      label: 'Selections',
      icon: ShoppingCart,
      route: routes.selections,
      badge: getSelectionBadge(),
    },
    { id: 'Orders', label: 'Orders', icon: Truck, route: routes.orders },
  ];

  const getBtnClass = (path) => {
    return location.pathname === path
      ? 'footer-btn footer-btn-active'
      : 'footer-btn footer-btn-inactive';
  };

  const getLabelClass = (path) => {
    return location.pathname === path ? 'footer-label-active' : 'footer-label';
  };

  return (
    <footer className="dashboard-footer">
      <nav className="footer-nav" aria-label="Main navigation">
        {footerItems.map((item) => {
          const IconComponent = item.icon;
          const isActive = location.pathname === item.route;
          return (
            <button
              key={item.id}
              className={getBtnClass(item.route)}
              onClick={() => navigate(item.route)}
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
              title={item.label}
            >
              <div className="footer-icon-with-badge">
                <IconComponent size={20} />
                {item.badge > 0 && (
                  <span className="footer-badge">{item.badge}</span>
                )}
              </div>
              <span className={getLabelClass(item.route)}>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </footer>
  );
};

export default Footer;
